import { Button, Flex, Modal } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import { useAuthorsStore } from '@/shared/stores/authors.store';

import { useDeleteAuthorMutation } from '../model/delete-author-modal.cases';

export function DeleteAuthorModal() {
  const deletableAuthor = useAuthorsStore((state) => state.deletableAuthor);
  const setDeletableAuthor = useAuthorsStore(
    (state) => state.setDeletableAuthors,
  );
  const deleteAuthorMutation = useDeleteAuthorMutation();

  return (
    <Modal
      opened={!!deletableAuthor}
      onClose={() => setDeletableAuthor(null)}
      title="Удаление автора"
    >
      {deletableAuthor && (
        <>
          <p>
            Вы действительно хотите удалить автора <b>{deletableAuthor.name}</b>
            ?
          </p>
          <Flex justify="space-between" gap={16} mt={20}>
            <Button
              variant="light"
              fullWidth
              onClick={() => setDeletableAuthor(null)}
            >
              Отмена
            </Button>
            <Button
              fullWidth
              color="red"
              loading={deleteAuthorMutation.isPending}
              onClick={() => {
                void deleteAuthorMutation
                  .mutateAsync(deletableAuthor.id)
                  .then((result) => {
                    setDeletableAuthor(null);
                    notifications.show({
                      message: 'Автор удалён',
                      color: 'green',
                    });
                    return result;
                  });
              }}
            >
              Удалить
            </Button>
          </Flex>
        </>
      )}
    </Modal>
  );
}
